// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"Interaction--keyboard_navigation_jump--3mr7-","notes_wrapper":"Interaction--notes_wrapper--l6rSw"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/Interaction/Interaction.css
// module id = 1023
// module chunks = 0